import { createStateSelectorHook } from 'src/lib/sweetState';

import { PerformanceStore } from './PerformanceStore';

const usePerformanceState = createStateSelectorHook(PerformanceStore, [
  'copiesMap',
  'copyPerformanceMap',
  'lastExtractionDateMap',
  'loadingStatusMap',
  'campaignsMap',
  'completionPercentMap',
  'campaignsCopyImpressionsMap',
  'connectingToChannelMap',
  'authErrorMessageMap',
  'errorMessageMap',
  'estimatedActionsDurationMap',
  'durationFromMap',
  'fetchedDataMap',
  'extractionStatusMap',
]);

export const useChannelAccountData = (channel, accountId) => {
  const {
    copiesMap,
    copyPerformanceMap,
    lastExtractionDateMap,
    loadingStatusMap,
    campaignsMap,
    completionPercentMap,
    campaignsCopyImpressionsMap,
    connectingToChannelMap,
    authErrorMessageMap,
    errorMessageMap,
    estimatedActionsDurationMap,
    durationFromMap,
    fetchedDataMap,
  } = usePerformanceState();

  return {
    copies: copiesMap[channel]?.[accountId] || [],
    copyPerformance: copyPerformanceMap[channel]?.[accountId],
    lastExtractionDate: lastExtractionDateMap[channel]?.[accountId] || null,
    loadingStatus: loadingStatusMap[channel]?.[accountId] || false,
    campaigns: campaignsMap[channel]?.[accountId] || [],
    completionPercent: completionPercentMap[channel]?.[accountId] || null,
    estimatedActionsDuration: estimatedActionsDurationMap[channel]?.[accountId] || [],
    durationFrom: durationFromMap[channel]?.[accountId] || null,
    fetchedData: fetchedDataMap[channel]?.[accountId] || false,
    campaignsCopyImpressions: campaignsCopyImpressionsMap[channel]?.[accountId] || [],
    connectingToChannel: connectingToChannelMap[channel] || false,
    authErrorMessage: authErrorMessageMap[channel] || null,
    errorMessage: errorMessageMap[channel]?.[accountId] || null,
  };
};
